// extracted by mini-css-extract-plugin
export default {"links":"NavigationLinks_links__kTFZw","link":"NavigationLinks_link__cuHWT"};